import React, { Component } from 'react';
import moment from 'moment';

import UrbioticaCounterSettingsForm from './UrbioticaCounterSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import UrbioticaCountersModel from './UrbioticaCountersModel';
import UserModel from './UserModel';

import { Table, Popconfirm, Divider, message, Typography } from 'antd';

class UrbioticaCountersTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        urbioticaCounterSettingsFormData: null
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Lokalita',
            dataIndex: 'parkingLocationName',
            key: 'parkingLocationName',
            width: 250,
            sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
        }, {
            title: 'POM',
            dataIndex: 'pom',
            key: 'pom',
            width: 100,
            sorter: (a, b) => defaultSorter(a.pom, b.pom)
        }, {
            title: 'Celková obsazenost',
            dataIndex: 'totalOcc',
            key: 'totalOcc',
            width: 70,
        }, {
            title: 'Poslední změna stavu',
            dataIndex: 'lastStateChange',
            key: 'lastStateChange',
            width: 185,
            sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
            render: (text, record) => {
                return (moment(record.lastStateChange).format('L LTS'))
            }
        }, {
            title: 'Akce',
            key: 'Action',
            width: 200,
            render: (text, record) => {
                if (UserModel.isInRoles(['ADMIN', 'URBIOTICA_COUNTERS_WRITE'])) {
                    return (
                        <div>
                            <a onClick={(e) => {
                                this.setState({
                                    urbioticaCounterSettingsFormData: record
                                });
                            }}>Nastavení</a>
                            <Divider type="vertical" />
                            <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                                this.props.onRemoveRow
                                    ? this.props.onRemoveRow(record.id)
                                    : null;
                            }} okText="Ano" cancelText="Ne">
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                            </Popconfirm>
                        </div>
                    );
                }
            }
        }];

        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    onChange={this.handleChange}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    style={{ border: '0px' }} />
                <UrbioticaCounterSettingsForm
                    type="modal"
                    modalVisible={this.state.urbioticaCounterSettingsFormData === null ? false : true}
                    initialValues={this.state.urbioticaCounterSettingsFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ urbioticaCounterSettingsFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        UrbioticaCountersModel.patch(this.state.urbioticaCounterSettingsFormData.id, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    urbioticaCounterSettingsFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
            </div>
        );
    }
}

export default UrbioticaCountersTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaCountersTable.js